import { useEffect, useContext, useState } from "react";
import AuthContext from "../../../../contexts/auth/AuthContext";
import UIContext from "../../../../contexts/ui/UIContext";
import SeedTypeSelectionCard from "./Card";
import Loading from "../../../ui-elements/Loading";
import ProduceTypeContext from "../../../../contexts/management/produceTypes/ProduceTypeContext";
import { useParams } from 'react-router-dom';

const List = ({ clickHandler }) => {
    const { accessibleSeedTypes, loading } = useContext(AuthContext);
    const { setInfo } = useContext(UIContext);
    const [showCurrent, setShowCurrent] = useState(true);
    const [showOutdated, setShowOutdated] = useState(false);
    const { allProduceTypes } = useContext(ProduceTypeContext);
    const {produceTypeId} = useParams();

    useEffect(() => {
        setInfo('Seed Type Selection');
        return () => {
            setInfo("Produce Type Management");
        }
    }, []);

    const currentProduceType = allProduceTypes?.find(produceType => produceType.id === produceTypeId);
    const currentSeedTypeId = currentProduceType?.seedTypeId;
    const assignedToOtherProduceTypeIds = new Set(
        (allProduceTypes ?? [])
            .filter(produceType => produceType.id !== produceTypeId)
            .map(produceType => produceType.seedTypeId)
    );
    const uniqueSeedTypes = Array.from(
        new Map(
            (accessibleSeedTypes ?? [])
                .filter(seedType => seedType?.id)
                .map(seedType => [seedType.id, seedType])
        ).values()
    );
    const sortByName = (a, b) => (a.name ?? '').localeCompare(b.name ?? '');
    const selectableSeedTypes = uniqueSeedTypes
        .filter(seedType => seedType.id === currentSeedTypeId
            || (!seedType.outdated && !assignedToOtherProduceTypeIds.has(seedType.id)))
        .sort(sortByName);
    const selectableOutdatedSeedTypes = uniqueSeedTypes
        .filter(seedType => seedType.id !== currentSeedTypeId
            && seedType.outdated
            && !assignedToOtherProduceTypeIds.has(seedType.id))
        .sort(sortByName);

    return loading ? <Loading fullScreen={true} /> : (
        <div className="select-seed-type-container">
            <div className="select-seed-type-accordion">
                <div className="produce-type-accordion-title" onClick={() => setShowCurrent(!showCurrent)}>
                    <div className="select-seed-type-icon">
                        <i className={showCurrent ? "fas fa-chevron-down" : "fas fa-chevron-right"}></i>
                    </div>
                    <div>
                        Current
                    </div>
                </div>
                <div className={"select-seed-type-list" + (showCurrent ? "-active" : "-inactive")}>
                    {showCurrent && (selectableSeedTypes.map((seedType) => {
                            return (
                                <SeedTypeSelectionCard key={seedType.id} seedType={seedType} clickHandler={clickHandler} />
                            );
                        }))}
                </div>
            </div>
                <div className="select-seed-type-accordion">
                <div className="produce-type-accordion-title" onClick={() => setShowOutdated(!showOutdated)}>
                    <div className="select-seed-type-icon">
                        <i className={showOutdated ? "fas fa-chevron-down" : "fas fa-chevron-right"}></i>
                    </div>
                    <div>
                        Deleted
                    </div>
                </div>
                <div className={"select-seed-type-list" + (showOutdated ? "-active" : "-inactive")}>
                    {showOutdated && selectableOutdatedSeedTypes.map((seedType) => {
                            return (
                                <SeedTypeSelectionCard key={seedType.id} seedType={seedType} clickHandler={clickHandler} />
                            );
                        })}
                </div>
            </div>
        </div>
    );
};

export default List;
